import { Button } from "@/components/ui/Button";
import * as shared from "@/styles/shared";
import { MapPin, Trash2 } from "lucide-react";
import { styles } from "../AddressesPage.styles";
import { useAddresses } from "./AddressesContext";

const AddressDialog = () => {
  const { dialogState, setState, handleSave, t } = useAddresses();
  const { mode, editing, name, error } = dialogState;

  if (mode !== "edit") return null;

  return (
    <div className={shared.dialogOverlay} onClick={() => setState({ dialogState: { mode: "closed", editing: null, name: "", error: "" } })}>
      <div className={shared.dialog} onClick={(e) => e.stopPropagation()}>
        <div className={styles.dialogHeader}>
          <MapPin className={styles.dialogIcon} />
          <h2 className={shared.headingLg}>{editing ? t("addresses:editAddress") : t("addresses:addAddress")}</h2>
        </div>
        <div className={styles.dialogBody}>
          {error && (
            <div className={shared.errorBox}>
              <Trash2 className={styles.errorIcon} />
              {error}
            </div>
          )}
          <div className={shared.formStack}>
            <label className={styles.formLabel}>{t("placeholder.addressName")}</label>
            <input
              value={name}
              onChange={(e) => setState({ dialogState: { ...dialogState, name: e.target.value } })}
              placeholder={t("placeholder.addressName")}
              className={shared.inputBase}
              autoFocus
            />
          </div>
          <div className={styles.buttonGroup}>
            <Button variant="secondary" onClick={() => setState({ dialogState: { mode: "closed", editing: null, name: "", error: "" } })}>
              {t("addresses:cancel")}
            </Button>
            <Button variant="gradient" onClick={handleSave}>
              {t("addresses:save")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { AddressDialog };
